import { Toaster as ToasterHot } from 'react-hot-toast'

import CheckRoundedIcon from '@mui/icons-material/CheckRounded'
import PriorityHighRoundedIcon from '@mui/icons-material/PriorityHighRounded'

import Box from '@mui/material/Box'
import { alpha, useTheme } from '@mui/material/styles'

import { frostedPill, iconTile } from '@utils/StylesHelper'
import { PAGE_BAR_HEIGHT } from '@components/Screen'

export default function Toaster() {
  const theme = useTheme()

  return (
    <ToasterHot
      position="top-center"
      containerStyle={styles.container}
      toastOptions={{
        duration: 5000,
        style: { ...frostedPill(theme), ...styles.pill },
        success: { icon: <Tile palette="success" Icon={CheckRoundedIcon} /> },
        error: { icon: <Tile palette="error" Icon={PriorityHighRoundedIcon} /> },
      }}
    />
  )
}

function Tile({ palette, Icon }) {
  return (
    <Box sx={styles.tile(palette)} aria-hidden="true">
      <Icon fontSize="small" />
    </Box>
  )
}

const styles = {
  container: { top: PAGE_BAR_HEIGHT + 16 },
  pill: { padding: '8px 2px 8px 12px', maxWidth: 420 },
  tile: (palette) => ({
    ...iconTile(28),
    color: `${palette}.main`,
    backgroundColor: (theme) => alpha(theme.palette[palette].main, 0.12),
  }),
}
